<div>
    <trips-header></trips-header>
    <trips-presentation></trips-presentation>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/trips/trips.html